export default __webpack_public_path__ + "static/media/base-report5.c28a4c66.png";